import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import useMutation from '../../../ReactQuery/useMutation';
import { put } from '../../../redux/api';
import type { FossaPlanName } from '../../../../shared/subscriptions/consts';
import type { ContractProps } from '../../subscriptions/useCurrentOrgContractProps';

type UpdatePlanRequest = {
  plan: FossaPlanName;
} & (
 | ContractProps
 | { custom_billing: boolean } // eslint-disable-line @typescript-eslint/naming-convention
);

//  PUT `/api/organization/custom_billing` request
const updateOrgBilling = (req: UpdatePlanRequest) =>
  put<UpdatePlanRequest, void>('/api/organization/custom_billing', req);

/**
 * Hook to update the billing plan for the current organization.
 */
export default function useUpdateOrgBilling() {
  const { onAlert } = useDialogContext();
  return useMutation<UpdatePlanRequest>({
    mutationFn: updateOrgBilling,
    onSuccess: () => {
      window.location.reload();
    },
    onError: () => {
      onAlert({
        title: 'Change Failed',
        body: 'Something went wrong while trying to change the subscription.',
      });
    },
  });
}
